(() => {
  // app/scripts/mega-tab-component.js
  var MegaTab = class extends HTMLElement {
    connectedCallback() {
      if (this.events && !this.events.signal.aborted) return;
      this.events = new AbortController();
      const { signal } = this.events;
      this.categories = Array.from(this.querySelectorAll(".jsMegaTabTitle")).filter((item) => item.closest("mega-tab") === this).map((item) => ({
        item,
        button: item.querySelector(":scope > .h5 > .jsMegaTabToggle"),
        panel: item.querySelector(":scope > .mega__tab-content") 
      })).filter((category) => category.button && category.panel);
      this.categories.forEach((category) => {
        category.button.setAttribute("aria-controls", category.panel.id);
        category.item.addEventListener("mouseenter", () => {
          // Hover must not remove a different panel holding keyboard focus.
          if (this.categories.some((other) => other !== category && other.panel.contains(document.activeElement))) return;
          this.selectCategory(category);
        }, { signal });
        category.item.addEventListener("tabChange", () => this.selectCategory(category), { signal });
      });
      this.addEventListener("click", (event) => {
        const category = this.categoryFor(event.target);
        if (!category || !category.button.contains(event.target) || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        this.selectCategory(category, category.button.getAttribute("aria-expanded") !== "true");
      }, { signal });
      this.addEventListener("keydown", (event) => {
        if (event.defaultPrevented) return;
        const category = this.categoryFor(event.target);
        if (!category || !category.button.contains(event.target)) return;
        const index = this.categories.indexOf(category);
        let next;
        if (event.key === "ArrowDown") next = this.categories[(index + 1) % this.categories.length];
        else if (event.key === "ArrowUp") next = this.categories[(index + this.categories.length - 1) % this.categories.length];
        else if (event.key === "Home") next = this.categories[0];
        else if (event.key === "End") next = this.categories.at(-1);
        else if (event.key !== "ArrowRight") return;
        // Only category-navigation keys are consumed. Tab remains native and
        // Escape continues to the existing outer Header disclosure controller.
        event.preventDefault();
        event.stopPropagation();
        if (next) {
          next.button.focus();
          this.selectCategory(next);
        } else {
          this.selectCategory(category);
          this.panelItems(category.panel)[0]?.focus();
        }
      }, { signal });
      this.closest("li")?.addEventListener("mouseleave", () => {
        if (!this.contains(document.activeElement)) this.selectCategory(this.categories[0]);
      }, { signal });
      this.selectCategory(this.categories.find((category) => category.item.classList.contains("active")));
    }
    disconnectedCallback() {
      this.events?.abort();
    }
    categoryFor(target) {
      const item = target.closest?.(".jsMegaTabTitle");
      return this.categories.find((category) => category.item === item);
    }
    selectCategory(selected, open = true) {
      const focused = document.activeElement;
      const closingFocused = this.categories.find((category) => category.panel.contains(focused) && (category !== selected || !open));
      this.categories.forEach((category) => {
        const active = category === selected && open;
        category.item.classList.toggle("active", active);
        category.item.classList.toggle("highlight", active);
        category.button.setAttribute("aria-expanded", String(active));
        category.panel.hidden = !active;
        category.panel.inert = !active;
        category.panel.setAttribute("aria-hidden", String(!active));
      });
      // Programmatic/editor selection can occur while a panel link is focused.
      // Return that focus to a visible control instead of leaving it hidden.
      if (closingFocused) (selected || closingFocused).button.focus();
    }
    panelItems(panel) {
      return Array.from(panel.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,summary,iframe,[tabindex],[contenteditable="true"]')).filter((item) => {
        if (item.matches(":disabled") || item.tabIndex < 0 || item.closest('[hidden],[inert],[aria-hidden="true"]') || !item.getClientRects().length || getComputedStyle(item).visibility === "hidden") return false;
        for (let ancestor = item.parentElement; ancestor; ancestor = ancestor.parentElement) {
          if (ancestor.tagName === "DETAILS" && !ancestor.open && !ancestor.querySelector(":scope > summary")?.contains(item)) return false;
        }
        return true;
      });
    }
  };
  if (!customElements.get("mega-tab")) customElements.define("mega-tab", MegaTab);
})();
